import PostHero from './hero';
import PostShort from './short';
import PostVideo from './video';
import PostDefault from './default';
import ListArticle from './list';
import GiftGuide from './gift';
import EventVideo from './event_video';

export {
  PostHero,
  PostShort,
  PostVideo,
  PostDefault,
  ListArticle,
  GiftGuide,
  EventVideo
};
